import { Instagram, Globe, Download } from "lucide-react";
import { RevealOnScroll, FadeUp } from "../../lib/motion";
import { useLang } from "../../i18n/LanguageContext";

export const QRCodes = () => {
  const { t } = useLang();
  const q = t.qr;

  const codes = [
    {
      key: "instagram",
      img: "/qr-instagram.png",
      label: q.instagram,
      value: "@hmsportconsulting",
      href: "https://www.instagram.com/hmsportconsulting",
      Icon: Instagram,
    },
    {
      key: "site",
      img: "/qr-site.png",
      label: q.site,
      value: "hmsportconsulting",
      href: "https://hmsportconsulting.com",
      Icon: Globe,
    },
  ];

  return (
    <section id="qr" className="bg-black text-white" data-testid="qr-section">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-24 md:py-32">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 md:mb-20 gap-6">
          <div>
            <FadeUp>
              <span className="text-sm md:text-base uppercase tracking-[0.25em] font-bold text-white/50">
                {q.label}
              </span>
            </FadeUp>
            <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.92] tracking-tight mt-6">
              {q.titleLines.map((line, i) => (
                <RevealOnScroll key={i} delay={i * 0.1}>
                  {line}
                </RevealOnScroll>
              ))}
            </h2>
          </div>
          <FadeUp delay={0.2} className="max-w-sm text-white/60 text-lg leading-relaxed">
            {q.subtitle}
          </FadeUp>
        </div>

        <div className="grid sm:grid-cols-2 gap-8 md:gap-10 max-w-4xl">
          {codes.map((c, i) => (
            <FadeUp key={c.key} delay={i * 0.12}>
              <div
                className="border border-white/20 p-8 md:p-10 flex flex-col items-center text-center"
                data-testid={`qr-card-${c.key}`}
              >
                <a
                  href={c.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`qr-link-${c.key}`}
                  className="bg-white p-3 md:p-4 transition-transform duration-300 hover:scale-[1.03]"
                >
                  <img
                    src={c.img}
                    alt={`QR code ${c.label} — HM Sport Consulting`}
                    className="w-32 h-32 md:w-40 md:h-40 object-contain"
                    data-testid={`qr-image-${c.key}`}
                  />
                </a>

                <div className="mt-7 flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-bold text-white/50">
                  <c.Icon size={16} /> {c.label}
                </div>
                <div className="mt-2 font-display font-bold uppercase text-xl md:text-2xl tracking-tight">
                  {c.value}
                </div>

                <a
                  href={c.img}
                  download={`qr-hm-${c.key}.png`}
                  data-testid={`qr-download-${c.key}`}
                  className="mt-6 inline-flex items-center gap-2 px-6 py-3 border border-white text-white text-xs uppercase tracking-[0.2em] font-bold transition-colors duration-300 hover:bg-white hover:text-black"
                >
                  <Download size={16} /> {q.download}
                </a>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QRCodes;
